<template>
  <transition name="fade">
    <div class="flash-message" v-if="visible">
      <h3 class="hidden">{{ message }}</h3>
      <span :class="icon"></span>
    </div>
  </transition>
</template>

<script>
export default {
  name: `FlashMessage`,
  computed: {
    message() {
      return this.$store.state.flashMessage.message;
    },
    visible() {
      return this.$store.state.flashMessage.visible;
    },
    icon() {
      if (
        this.message === "הוסף למועדפים" ||
        this.message === "הוסר מהמועדפים"
      ) {
        return "mdi mdi-heart";
      }
      return "mdi mdi-check-circle";
    },
  },
};
</script>

<style lang="scss">
$pinky: #fd7170;
$white: #ffffff;
.flash-message {
  position: fixed;
  top: 100px;
  color: $white;
  z-index: 500;
  background-color: $pinky;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 2rem;

  .hidden {
    display: none;
  }
}
</style>
